import { useSelector } from 'react-redux';
import { useFreeTrialUpgradeModal } from '../../../../common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import { useConnectedPageCRUDActions } from '@mm/state/actions/ConnectedPageCRUDActions';
import { usePromoterCRUDActions } from '@mm/state/actions/PromoterCRUDActions';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import {
  activeChatbotSelector,
  chatbotIsActiveOnConnectedPageSelector,
} from '@mm/state/selectors/viewSelectors';
import { useShowInactiveBannerFlag } from '../../../common/hooks/use-show-inactive-bot-banner-flag';
import { ActivationWarningModal } from '../customerChat/CustomerChatEditor/ActivationWarningModal/ActivationWarningModal';

export const usePromoterActivator = (promoter: PromoterModel | undefined) => {
  const chatbot = useSelector(activeChatbotSelector);

  const chatbotIsActiveOnConnectedPage = useSelector(
    chatbotIsActiveOnConnectedPageSelector,
  );
  const promoterCRUDActions = usePromoterCRUDActions();
  const connectedPageCRUDActions = useConnectedPageCRUDActions();
  const facebookPage = useSelector(activeFacebookPageSelector);
  const { isFreeTrialPromotionWithoutSubscription } =
    useFreeTrialUpgradeModal();
  const { openActivateInactiveBotModal, openGeneralTextModal } =
    useModalActions();
  const { onClickActivate } = useShowInactiveBannerFlag();

  const togglePromoterActivation = () => {
    if (!promoter) {
      return;
    }

    promoterCRUDActions.update(chatbot.id, {
      ...promoter,
      active: !promoter.active,
    });

    if (
      isFreeTrialPromotionWithoutSubscription &&
      !facebookPage?.webChatActivated &&
      facebookPage &&
      promoter.kind === 'customer_chat'
    ) {
      openGeneralTextModal({
        header: ActivationWarningModal.Header,
        headerClassName: ActivationWarningModal.headerClassName,
        message: ActivationWarningModal.Message,
        closeButtonText: 'Got it!',
      });
      connectedPageCRUDActions.retrievePage(facebookPage.id);
    }
  };

  const activatePromoter = () => {
    if (promoter) {
      if (!chatbotIsActiveOnConnectedPage && !promoter.active) {
        openActivateInactiveBotModal({
          onBotActivateConfirm: () =>
            setTimeout(() => onClickActivate(togglePromoterActivation), 500),
          useCustomOnBotActivateConfirm: true,
        });
      } else {
        togglePromoterActivation();
      }
    }
  };

  return {
    activatePromoter,
  };
};
